export class FileUtil {
  public static removeExt(fileName: string) {
    if (fileName.indexOf('.pdf') < 0) return fileName;
    return fileName.split('.').slice(0, -1).join('.');
  }
}
